import { useContext } from "react";
import styled from "styled-components";
import { PageContext } from "../Context/PageContext";

  function Tooltip(props){

    const { ToolTipContent } = useContext(PageContext)

    return(

            <TipBox tiprgba={props.rgba} id={"tipBox"}>
              <TextContainer id="tipBoxText">
              </TextContainer>
              <Edge id="tipBoxEdge"></Edge>
            </TipBox>    
    );
};

function TipMouseOverEvent (event, tipPhrase, rgba) {
    

    var tipBox = document.getElementById("tipBox");
    var tipBoxText = document.getElementById("tipBoxText");
    var tipBoxEdge = document.getElementById("tipBoxEdge");

    tipBoxText.innerHTML = tipPhrase;
    
    tipBox.style.opacity = 1;
    tipBoxText.style.backgroundColor = rgba;
    tipBoxEdge.style.borderTopColor = rgba;
    

    var widthTipBox = tipBox.getBoundingClientRect().right - tipBox.getBoundingClientRect().left;
    var targetWidth = event.target.getBoundingClientRect().right - event.target.getBoundingClientRect().left;
    var heightTipBox = tipBox.getBoundingClientRect().top - tipBox.getBoundingClientRect().bottom;

    tipBox.style.left = event.target.getBoundingClientRect().left - widthTipBox/2 + targetWidth/2 + "px";

    tipBox.style.top = event.target.getBoundingClientRect().top + heightTipBox - 20 + window.scrollY + "px";


  };

  function TipMouseOutEvent () {
    var tipBox = document.getElementById("tipBox");
    tipBox.style.opacity = 0;
    tipBox.style.top = tipBox.getBoundingClientRect().top + 30 + window.scrollY + "px";

  };


  const TipBox = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
    position: absolute;
    opacity: 0;
    transition: .3s;
    z-index: 70;
    pointer-events: none;
  `

  const TextContainer = styled.span`
     padding: 10px 20px;
     border-radius: 5px;
     background-color: rgba(0,0,0,1);
     color: white;

  `

  const Edge = styled.div`
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 10px solid #5386E4;
    transition: .3s;

  `

  // Mouse Events Need to be include in JSX element
  // onMouseOver={(event) => TipMouseOverEvent(event, "Youtube Channel", "rgb(0,0,0,1))} onMouseLeave={() => TipMouseOutEvent()}

  export default Tooltip;
  export {TipMouseOutEvent, TipMouseOverEvent};